<template>
  <div class="history" v-if="list && list.length">
    <div class="h-top">
      <div class="title">历史搜索</div>
      <div class="del iconfont icon-shanchu" @click="bindDelete"></div>
    </div>
    <div class="history-list">
      <div
        class="history-item"
        @click="bindClick(item)"
        v-for="(item, index) in list"
        :key="index"
        >{{ item }}</div
      >
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindDelete() {
      this.$emit('delete')
    },
    bindClick(item) {
      this.$emit('search', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.history {
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 18px;
  .h-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .title {
      font-weight: bold;
      font-size: 16px;
      line-height: 20px;
    }

    .del {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #d1d1d3;
      font-size: 18px;
    }
  }

  .history-list {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    max-height: 80px;
    overflow: hidden;
    .history-item {
      max-width: 150px;
      padding: 0px 12px;
      box-sizing: border-box;
      height: 28px;
      line-height: 28px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      background: #f1f1f3;
      border-radius: 14px;
      margin-right: 10px;
      margin-bottom: 12px;
    }
  }
}
</style>
